import React from "react";
// import "./whyUs.css";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";


const features = [
  {
    title: "Experience and Expertise ",
    desc: "Years of experience delivering advanced blockchain solutions across diverse industries. Skilled team providing practical and scalable blockchain integrations.",
    image: "./img/5639784_2961089.svg",
  },
  {
    title: "Reliable & Scalable Development",
    desc: "We create well-planned and stable systems that continue to work smoothly after delivery, so you don’t have to worry about future issues or performance problems.",
    image: "./img/7176408_3572684.svg",
  },
  {
    title: "Timely Delivery",
    desc: "Committed to delivering projects on time, while maintaining quality, efficiency and continuous communication throughout development.",
    image: "./img/5205022_Delivery.svg",
  },
  {
    title: "Innovation and Adaptability",
    desc: "Continuously innovating and adapting to new technologies while ensuring scalable and future-ready solutions for clients.",
    image: "./img/inn.png",
  },
  {
    title: "Support and Maintenance",
    desc: "Providing continuous support and maintenance services ensuring smooth performance and long-term reliability.",
    image: "./img/8821548_4018854.svg",
  },
];


export default function WhyUs() {

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const fadeInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.6 }
    }
  };

  const fadeInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.6 }
    }
  };


  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };
  return (
    <div>
       <Helmet>
          <meta charset="UTF-8" />
          <link rel="icon" href="/img/CML_LOGO.png" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="theme-color" content="#000000" />
          <meta
            name="description"
            content="Chain Magician Lab - Your one-stop solution for all software requirements. We specialize in blockchain development, including Ethereum development and smart contracts. Our mobile application services cover e-commerce apps, gaming apps, Web3 apps, and more. We also provide custom software solutions tailored to your business needs, along with decentralized application development and secure, scalable software solutions."
          />
          <title>
            Chain Magician Lab | Blockchain, Mobile & Custom Software Development
          </title>
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.chainmagicianlab.com/" />
          <meta
            property="og:title"
            content="Chain Magician Lab | Blockchain, Mobile & Custom Software Development"
          />
          <meta
            property="og:description"
            content="Chain Magician Lab offers high-quality blockchain development, mobile app creation including e-commerce, gaming, and Web3 apps, and custom software solutions to meet your business needs."
          />
          <meta
            property="og:image"
            content="https://www.chainmagicianlab.com/img/CML_LOGO.png"
          />
          <meta property="twitter:card" content="summary_large_image" />
          <meta
            property="twitter:url"
            content="https://www.chainmagicianlab.com/"
          />
          <meta
            property="twitter:title"
            content="Chain Magician Lab | Blockchain, Mobile & Custom Software Development"
          />
          <meta
            property="twitter:description"
            content="Chain Magician Lab provides comprehensive software solutions including blockchain development, mobile apps (e-commerce, gaming, Web3), custom software, decentralized applications, and smart contracts."
          />
          <meta
            property="twitter:image:alt"
            content="https://www.chainmagicianlab.com/img/CML_LOGO.png"
          />
          <link rel="canonical" href="https://www.chainmagicianlab.com/" />
          <meta
            name="keywords"
            content="Blockchain development, Blockchain development company in India, Best blockchain company, Ethereum development services, Smart contract development, Smart contract developers India, dApp development company, Decentralized application development, Crypto exchange development India, Centralized exchange (CEX) development, Decentralized exchange (DEX) development, DEX aggregator platform, DEX liquidity pools, DEX security audits, DEX smart contracts, Cross-chain DEX development, Crypto arbitrage trading, Yield farming platform development, DeFi development company, DeFi staking platforms, DeFi lending protocols, DeFi token development, Cryptocurrency development, Crypto coin development, Crypto wallet development, Mobile crypto wallets, Web crypto wallets, Custodial and non-custodial wallets, ICO development company, STO development company, Token development services, Top token development company India, ERC-20 token development, BEP-20 token development, NFT token development, NFT marketplace development India, NFT smart contract solutions, NFT game development, Play-to-earn game development, NFT launchpad development, Tokenomics consulting, Token audit services, Token liquidity management, Token sale strategy, Token staking platform, Token governance models, Web3 integration company, Web3 application development, Web3 wallets, Web3 projects, Web3 APIs, Web3 infrastructure solutions, Web3 scalability, Web3 consulting India, Decentralized web solutions, DAO development services, Metaverse development company, Blockchain in healthcare India, Blockchain in supply chain India, Blockchain in fintech India, Blockchain consulting services, Blockchain architecture design, Blockchain protocol development, Blockchain auditing company, Blockchain security testing, Private blockchain development, Hyperledger development, Enterprise blockchain solutions, Blockchain IoT integration, AI and blockchain solutions, MLM software development company India, Best MLM software company, MLM compensation plans, Binary MLM plan software, Matrix MLM plan development, Unilevel MLM plan, Hybrid MLM software, Forced matrix MLM, MLM income calculator India, MLM business model solutions, MLM software features, MLM strategy consulting, MLM apps development, MLM software with blockchain, MLM company reviews India, Custom MLM software solutions, Mobile app development services, iOS app development India, Android app development company, Cross-platform mobile apps, Native app development services, Enterprise mobile app development, Mobile app UI/UX design, App store optimization, Mobile app testing services, Mobile app marketing, Mobile app maintenance, App deployment services, Custom mobile application solutions, Custom software development, Software development company in India, Enterprise software development, SaaS development company, PaaS development, Cloud software solutions, Software consulting India, Software modernization services, Bespoke software development, Software integration solutions, E-commerce website development India, Shopify development company India, Magento development, WooCommerce development, Custom e-commerce app development, Multi-vendor marketplace India, Online store development, E-commerce strategy consulting, E-commerce SEO services, Gaming app development company, Unity game development India, Unreal Engine game development, VR game development, AR game development, 2D game development, 3D game development, Multiplayer game apps, Educational game apps, Casual game development, Indie game development, Game monetization strategy, Blockchain gaming solutions, Play-to-earn game apps, Web3 gaming platforms, Crypto game development, Best blockchain consulting company India, Top blockchain companies in India, Best token development services, Crypto exchange developers India, Web3 developers India, Mobile app developers India, Custom software company India, Blockchain startup solutions, Token launch services, ICO launch company India.
  "
          ></meta>
          <script type="application/ld+json">
            {`
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Chain Magician Lab",
    "url": "https://www.chainmagicianlab.com",
    "logo": "https://www.chainmagicianlab.com/img/CML_LOGO.png",
    "tagline": "Magic in every line of software.",
    "description": "Chain Magician Lab specializes in blockchain development, Web3 integration, custom software, mobile apps, ecommerce apps, gaming apps, AI, and IoT solutions. We deliver innovative technology with strong expertise and nation-first vision.",
    "founder": {
      "@type": "Person",
      "name": "Anmol",
      "jobTitle": "Founder"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+91-6393561379",
        "contactType": "customer support",
        "areaServed": "IN",
        "availableLanguage": ["English", "Hindi"]
      },
      {
        "@type": "ContactPoint",
        "email": "chainmagicianlab@gmail.com",
        "contactType": "sales",
        "areaServed": "IN"
      }
    ],
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "India"
    },
    "sameAs": [
      "https://www.linkedin.com/company/chain-magician-lab",
      "https://twitter.com/chainmagicianlab",
      "https://t.me/decryptcoders"
    ],
    "makesOffer": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Blockchain Development",
          "description": "End-to-end blockchain solutions, custom smart contracts, and decentralized applications."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Web3 Integration",
          "description": "Seamless wallet integration, dApps, NFT marketplaces, and DeFi solutions."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Custom Software Development",
          "description": "Bespoke software tailored for businesses across industries."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Mobile Application Development",
          "description": "iOS, Android, Flutter, and React Native apps with modern UI/UX."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Ecommerce App Development",
          "description": "Secure and scalable ecommerce applications with payment integration."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Gaming Application Development",
          "description": "High-performance game development with Web3 and traditional support."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "AI & Machine Learning Solutions",
          "description": "AI-driven software, predictive analytics, and intelligent automation."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "IoT Solutions",
          "description": "Smart IoT development with focus on industrial and defense applications."
        }
      }
    ]
  }
  `}
          </script>
        </Helmet>
        <section  id="ourvalue" className="bg-gradient-to-b from-[#02140d] to-[#000000] text-white py-24 px-4 md:px-6 relative overflow-hidden">
      
      {/* Background Pattern with subtle animation */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.5 }}
        transition={{ duration: 1.5 }}
        className="absolute inset-0"
      >
        <div className="absolute top-20 left-20 w-64 h-64 bg-green-500/10 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-64 h-64 bg-emerald-500/10 rounded-full filter blur-3xl"></div>
      </motion.div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <motion.div 
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeInUp}
          className="text-center mb-20"
        >
          <h2 className="text-3xl md:text-5xl font-bold mb-4 ">
            Why{" "}
            <motion.span 
              whileHover={{ scale: 1.05 }}
              className="bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent inline-block"
            >
              Chain Magician
            </motion.span>
          </h2>
          <motion.div 
            initial={{ width: 0 }}
            whileInView={{ width: "6rem" }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="h-1 bg-gradient-to-r  from-green-400 to-emerald-400 mx-auto rounded-full"
          />
        </motion.div>

        {/* Features Grid with Zigzag Layout */}
        <motion.div 
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="space-y-16 md:space-y-24"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              variants={fadeInUp}
              className={`grid md:grid-cols-2 gap-8 md:gap-12 items-center ${
                index % 2 === 1 ? "md:[&>div:first-child]:order-2 md:[&>div:last-child]:order-1" : ""
              }`}
            >
              {/* Content Side */}
              <motion.div 
                variants={index % 2 === 0 ? fadeInLeft : fadeInRight}
                className="space-y-4 md:space-y-6"
              >
                {/* Number Badge */}
                <div className="inline-flex items-center gap-3">
                  <motion.span 
                    initial={{ opacity: 0, scale: 0.5 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.2, delay: index * 0.1 }}
                    className="text-5xl md:text-6xl font-bold text-white/20 group-hover:text-white/30 transition-colors duration-300"
                  >
                    {String(index + 1).padStart(2, '0')}
                  </motion.span>
                </div>

                {/* Title */}
                <motion.h3 
                  whileHover={{ x: 5 }}
                  className="text-2xl md:text-3xl font-bold text-white"
                >
                  {feature.title}
                </motion.h3>

                {/* Description */}
                <motion.p 
                  whileHover={{ x: 3 }}
                  className="text-gray-300 text-base md:text-lg leading-relaxed"
                >
                  {feature.desc}
                </motion.p>

                {/* Feature List (Optional) */}
                <motion.div 
                  whileHover={{ x: 5 }}
                  className="pt-4"
                >
                  <div className="flex items-center gap-2 text-green-400">
                    <motion.svg 
                      animate={{ 
                        scale: [1, 1.1, 1],
                      }}
                      transition={{ 
                        duration: 2,
                        repeat: Infinity,
                        repeatType: "reverse"
                      }}
                      className="w-5 h-5" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </motion.svg>
                    <span className="text-sm font-medium">Trusted by industry leaders</span>
                  </div>
                </motion.div>
              </motion.div>

              {/* Image Side */}
              <motion.div 
                variants={index % 2 === 0 ? fadeInRight : fadeInLeft}
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
                className={`relative ${index % 2 === 1 ? 'md:justify-start' : 'md:justify-end'} flex justify-center`}
              >
                {/* Image Container */}
                <div className="relative w-64 h-64 md:w-80 md:h-80">
                  {/* Gradient Background */}
                  <motion.div 
                    animate={{ 
                      rotate: [0, 6, 0],
                    }}
                    transition={{ 
                      duration: 8,
                      repeat: Infinity,
                      repeatType: "reverse"
                    }}
                    className="absolute inset-0 bg-gradient-to-tr from-green-500/20 to-emerald-500/20 rounded-2xl"
                  />
                  
                  {/* Image Frame */}
                  <motion.div 
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                    className="absolute inset-0 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 overflow-hidden"
                  >
                    <motion.img
                      initial={{ scale: 1 }}
                      whileHover={{ scale: 1.15 }}
                      transition={{ duration: 0.4 }}
                      src={feature.image}
                      alt={feature.title}
                      className="w-full h-full object-contain p-8"
                    />
                  </motion.div>

                  {/* Decorative Elements */}
                  <motion.div 
                    animate={{ 
                      rotate: 360,
                    }}
                    transition={{ 
                      duration: 20,
                      repeat: Infinity,
                      ease: "linear"
                    }}
                    className="absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-r from-green-400 to-emerald-400 rounded-lg opacity-20"
                  />
                  <motion.div 
                    animate={{ 
                      rotate: -360,
                    }}
                    transition={{ 
                      duration: 20,
                      repeat: Infinity,
                      ease: "linear"
                    }}
                    className="absolute -bottom-4 -left-4 w-12 h-12 bg-gradient-to-r from-green-400 to-emerald-400 rounded-lg opacity-20"
                  />
                </div>
              </motion.div>
            </motion.div>
          ))}
        </motion.div>

        {/* Bottom CTA */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-20 text-center"
        >
          <motion.button 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="group relative inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white font-semibold rounded-xl overflow-hidden hover:shadow-lg hover:shadow-green-500/25 transition-all duration-300"
          >
            <span className="relative z-10">Start Your Project</span>
            <motion.svg 
              animate={{ x: [0, 5, 0] }}
              transition={{ 
                duration: 1.5,
                repeat: Infinity,
                repeatType: "reverse"
              }}
              className="relative z-10 w-5 h-5" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </motion.svg>
            <div className="absolute inset-0 bg-gradient-to-r from-green-600 to-emerald-600 opacity-0 group-hover:opacity-100 transition-opacity"></div>
          </motion.button>
        </motion.div>
      </div>
    </section>
    </div>
  );
}
